import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Spin, Typography } from 'antd';
import { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import ResellerDashboard from '../../ResellerDashboard/ResellerDashboard';
import { ResellerSiderItem } from 'src/enums/IResellerSiderItems';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { getTutorialBySlug, getResellerAcademy } from '@/store/resellerAcademy/selector';
import { AppRoutes } from 'src/enums/ERoutes';
import { PdfContent } from '@/interfaces/IResellerAcademy';
import './TutorialViewer.scss';

const TutorialViewer = () => {
	const { Title } = Typography;
	const { tutorialSlug, chapterId } = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const { loading } = useAppSelector(getResellerAcademy);
	const tutorial = useAppSelector(getTutorialBySlug(Number(chapterId), tutorialSlug as string)) as
		| PdfContent
		| undefined;
	const [isFrameLoaded, setIsFrameLoaded] = useState(false);

	// Get the tutorial URL from location state
	const tutorialUrl = location.state?.tutorialUrl || tutorial?.key || '';

	// Handle iframe load event
	const handleIframeLoad = () => {
		setIsFrameLoaded(true);
	};

	// Reset the loading state if navigation changes
	useEffect(() => {
		return () => {
			setIsFrameLoaded(false);
		};
	}, [tutorialSlug, chapterId]);

	return (
		<ResellerDashboard activeKey={ResellerSiderItem.ACADEMY} showHeader={false}>
			<Spin spinning={loading || !isFrameLoaded}>
				<div className="tutorial-viewer__container">
					<div className="tutorial-viewer__header">
						<Button
							icon={<ArrowLeftOutlined />}
							onClick={() =>
								navigate(
									AppRoutes.RESELLER_ACADEMY_CHAPTER.replace(':chapterId', chapterId as string),
								)
							}
							className="tutorial-viewer__back-button"
						>
							Back to Chapter
						</Button>

						<div className="tutorial-viewer__title-section">
							<Title level={2} className="tutorial-viewer__title">
								{tutorial?.title || 'Interactive Tutorial'}
							</Title>
						</div>
					</div>

					<div className="tutorial-viewer__content">
						<div className="tutorial-viewer__iframe-container">
							{tutorialUrl && (
								<iframe
									src={tutorialUrl}
									className="tutorial-viewer__iframe"
									onLoad={handleIframeLoad}
									frameBorder="0"
									allowFullScreen
								/>
							)}
						</div>
					</div>
				</div>
			</Spin>
		</ResellerDashboard>
	);
};

export default TutorialViewer;
